import ConfirmationDialog from "@/components/common/ConfirmationDialog";
import { useGetShareOfVoiceMetricsTableData } from "@/components/share-of-voice/metrics-table/useMetricsTable";
import { DialogOverlay } from "@/components/ui/dialog";
import { deleteSegment } from "@/store/share-of-voice/segment/segment-async.actions";
import useSegmentStore from "@/store/share-of-voice/segment/segment.slice";

const DeleteSegmentModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const deleteSegmentId = useSegmentStore((state) => state.deleteSegmentId);
  const isDeletingSegment = useSegmentStore((state) => state.isDeletingSegment);
  const resetDeleteSegment = useSegmentStore(
    (state) => state.resetDeleteSegment,
  );
  const segmentName = useSegmentStore((state) => state.name);
  const { refetch: refetchTableData } = useGetShareOfVoiceMetricsTableData();

  const handleClose = () => {
    onClose();
    resetDeleteSegment();
  };

  const handleDelete = async () => {
    if (!deleteSegmentId) return;

    try {
      await deleteSegment(deleteSegmentId, segmentName);
      // Refetch the metrics table data after successful deletion
      refetchTableData();
    } catch (error) {
      // Error handling is done in the deleteSegment action
      console.error("Failed to delete segment:", error);
    }
  };

  return (
    <DialogOverlay isOpen={isOpen}>
      <ConfirmationDialog
        onCancelClick={handleClose}
        onSubmitClick={handleDelete}
        submitText="Yes, delete"
        submitVariant="secondaryDestructive"
        submittingText="Deleting"
        title={`Are you sure you want to remove "${segmentName}"?`}
        submitLoading={isDeletingSegment}
      >
        <p className={"text-sm text-gray-800"}>
          This will remove this segment from your Competitive Share of Voice
          segment. This will not impact your newsfeeds etc
        </p>
      </ConfirmationDialog>
    </DialogOverlay>
  );
};
export default DeleteSegmentModal;
